<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-28 13:27:43
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-11-13 15:35:02
 * @FilePath: /wemeet-admin-new/src/views/data/components/channelAnalysis.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="dialogCard" style="margin-top: 20px; width: 100%">
    <div class="subBox">
      <div class="title">
        <span>渠道统计</span>
        <!-- <el-tooltip effect="dark" content="用户访问人数、报名、签到等关键数据，连续多天的趋势" placement="top-start">
          <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/tips.png" alt="" class="tipsIcon">
        </el-tooltip> -->
      </div>
      <!-- <div class="chooseTime">
        <span class="timeLabel">选择时间</span>
        <el-date-picker v-model="timeRange" type="daterange" :shortcuts="shortcuts" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" :disabled-date="disabledDate" @focus="handleFocus" @calendar-change="handleChange" @change="pickerChange" />
      </div> -->
    </div>
    <div class="subTitle">更新时间：{{ nowTime }}</div>

    <el-row>
      <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24">
        <vab-chart
          v-if="aiApplicationType == 'EXHIBITION'"
          :option="option"
          style="height: 390px; width: 100%"
          theme="vab-echarts-theme"
        />
        <vab-chart v-else :option="option1" style="height: 390px; width: 100%" theme="vab-echarts-theme" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { defineComponent, reactive, toRefs, watch } from 'vue'
  import _ from 'lodash'
  import VabChart from '@/extra/VabChart'
  import VabCount from '@/extra/VabCount'

  export default defineComponent({
    components: {
      VabChart,
      VabCount,
    },
    props: {
      data: {
        type: Object,
        default: {},
      },
      nowTime: {
        type: String,
        default: '',
      },
      aiApplicationType: {
        type: String,
        default: 'EXHIBITION',
      },
    },
    setup(props, { emit }) {
      watch(
        () => props.data,
        (newVal, oldVal) => {
          console.log(newVal, 'vvvv')
          handleBarData(newVal)
        }
      )
      const state = reactive({
        countConfig: {
          startVal: 0,
          endVal: _.random(1000, 5555),
          decimals: 0,
          prefix: '',
          suffix: '',
          separator: ',',
          duration: 8000,
          suf: '次',
        },
        timeRange: [],
        shortcuts: [
          {
            text: '上一周',
            value: () => {
              const end = new Date()
              const start = new Date()
              start.setDate(start.getDate() - 7)
              return [start, end]
            },
          },
          {
            text: '上个月',
            value: () => {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth() - 1)
              return [start, end]
            },
          },
          {
            text: '前三个月',
            value: () => {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth() - 3)
              return [start, end]
            },
          },
        ],
        option: {
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              let str = params[0].name + '<br/>'
              let value1 =
                params[0].marker +
                params[0].seriesName +
                `<span style='width:10px;display: inline-block;'></span>` +
                params[0].value +
                '人' +
                '<br/>'
              let value2 =
                params[1].marker +
                params[1].seriesName +
                `<span style='width:10px;display: inline-block;'></span>` +
                params[1].value +
                '人' +
                '<br/>'
              let value3 =
                params[2].marker +
                params[2].seriesName +
                `<span style='width:10px;display: inline-block;'></span>` +
                params[2].value +
                '人' +
                '<br/>'
              str += value1 + value2 + value3
              return str
            },
            axisPointer: {
              type: 'shadow',
            },
          },
          legend: {},
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: [
            {
              type: 'category',
              data: [],
            },
          ],
          yAxis: [
            {
              type: 'value',
              name: '单位（人）',
              nameTextStyle: {
                color: '#4e5969',
              },
            },
          ],
          series: [
            {
              name: '签到',
              type: 'bar',
              emphasis: {
                focus: 'series',
              },
              itemStyle: {
                normal: {
                  color: '#0098FA',
                },
              },
              data: [],
            },
            {
              name: '展前注册',
              type: 'bar',
              stack: 'Ad',
              emphasis: {
                focus: 'series',
              },
              itemStyle: {
                normal: {
                  color: '#3B72AD',
                },
              },
              data: [],
            },
            {
              name: '展中注册',
              type: 'bar',
              stack: 'Ad',
              emphasis: {
                focus: 'series',
              },
              itemStyle: {
                normal: {
                  color: '#00C4C9',
                },
              },
              data: [],
            },
          ],
        },
        option1: {
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              let str = params[0].name + '<br/>'
              let value1 =
                params[0].marker +
                params[0].seriesName +
                `<span style='width:10px;display: inline-block;'></span>` +
                params[0].value +
                '人' +
                '<br/>'
              str += value1
              return str
            },
            axisPointer: {
              type: 'shadow',
            },
          },
          legend: {},
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: [
            {
              type: 'category',
              data: [],
            },
          ],
          yAxis: [
            {
              type: 'value',
              name: '单位（人）',
              nameTextStyle: {
                color: '#4e5969',
              },
            },
          ],
          series: [
            {
              name: '注册',
              type: 'bar',
              emphasis: {
                focus: 'series',
              },
              itemStyle: {
                normal: {
                  color: '#0098FA',
                },
              },
              data: [],
            },
          ],
        },
      })

      const handleBarData = (val) => {
        if (props.aiApplicationType == 'EXHIBITION') {
          let yData = []
          let seriesData = []
          let series1Data = []
          let series2Data = []
          val.forEach((v) => {
            console.log(v, '=====???vvv')
            yData.push(v.name)
            seriesData.push(v.meetingSignInNum)
            series1Data.push(v.beforeSignUpNum)
            series2Data.push(v.middleSignUpNum)
          })
          state.option.xAxis[0].data = yData
          state.option.series[0].data = seriesData
          state.option.series[1].data = series1Data
          state.option.series[2].data = series2Data
          console.log(state.option)
        } else {
          let yData = []
          let seriesData = []
          val.forEach((v) => {
            yData.push(v.name)
            seriesData.push(v.beforeSignUpNum + v.middleSignUpNum)
          })
          state.option1.xAxis[0].data = yData
          state.option1.series[0].data = seriesData
        }
      }

      const handleChange = (val) => {
        console.log(val)
        const [pointDay] = val
        state.chooseDay = pointDay
        console.log(pointDay)
      }

      const pickerChange = (val) => {
        console.log(val, '=-==')
        emit('changeChannel', val)
      }
      //取值方法
      const handleFocus = () => {
        state.chooseDay = null
      }
      const disabledDate = (time) => {
        if (!state.chooseDay) {
          return false
        }
        let timeRange = 30
        const con1 = new Date(state.chooseDay).getTime() - timeRange * 24 * 60 * 60 * 1000
        const con2 = new Date(state.chooseDay).getTime() + timeRange * 24 * 60 * 60 * 1000
        return time < con1 || time > con2
      }

      window.onresize = () => {
        console.log(`resize`)
      }
      return {
        ...toRefs(state),
        handleChange,
        handleFocus,
        disabledDate,
        pickerChange,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .dialogCard {
    width: 100%;
    min-height: 174px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    padding: 20px;
    box-sizing: border-box;
    .subTitle {
      font-size: 12px;
      color: #4e5969;
    }
    .subBox {
      display: flex;
      justify-content: space-between;
      .title {
        font-weight: 500;
        font-size: 16px;
        color: #1d2129;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        .tipsIcon {
          width: 18px;
          height: 18px;
          margin-left: 8px;
        }
      }
      .chooseTime {
        .timeLabel {
          font-size: 14px;
          color: #4e5969;
          margin-right: 16px;
        }
      }
    }
  }
</style>
